import {get, post} from '~/utils/request';

export function getResumeInfoByCode(data){
  return post('/Marketing/GetResumeInfoByCode', data);
}

export function getMeQrCode(data){
  return post('/Marketing/GetMeQrCode', data);
}